import { render, staticRenderFns } from "./RestaurantsSearchBanner.vue?vue&type=template&id=3cfef9e4&"
import script from "./RestaurantsSearchBanner.vue?vue&type=script&lang=ts&"
export * from "./RestaurantsSearchBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cfef9e4')) {
      api.createRecord('3cfef9e4', component.options)
    } else {
      api.reload('3cfef9e4', component.options)
    }
    module.hot.accept("./RestaurantsSearchBanner.vue?vue&type=template&id=3cfef9e4&", function () {
      api.rerender('3cfef9e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "module/Deals/view/vue/RestaurantsSearchBanner.vue"
export default component.exports